import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import * as classroomActions from '../../../../actions/classroom/classroomActions';
import emptyClassRoomPlaceholder from '../../../../images/emptyHomePlaceholder.png';

class EmptyClassroomPlaceholder extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = { enrollClassCodePlaceholder: '' };
  }

  static propTypes = {
    emptyClassrooms: PropTypes.any,
    classroomActions: PropTypes.any,
    enableEnrollment: PropTypes.bool
  };

  classCodeHandler() {
    let { enrollClassCodePlaceholder } = this.refs;
    if (enrollClassCodePlaceholder.value && enrollClassCodePlaceholder.value.length === 4) {
      const { classroomActions } = this.props;
      classroomActions.enrollClassroom(enrollClassCodePlaceholder.value).then(() => {
        enrollClassCodePlaceholder.value = '';
      });
    }
  }

  addDefaultSrc(ev) {
    ev.target.src = emptyClassRoomPlaceholder;
  }

  render() {
    const { enableEnrollment, emptyClassrooms } = this.props;
    return (
      <div className="empty-classroom-placeholder">
        <div className="content">
          <img src={emptyClassrooms} onError={this.addDefaultSrc} alt="presentation" />
          <div className="text-title">
            {enableEnrollment
              ? I18n.t('home.student.empty.title')
              : I18n.t('home.student.empty.title-enrollmentNotEnabled')}
          </div>
          <div className="text-info">
            {enableEnrollment
              ? I18n.t('home.student.empty.info')
              : I18n.t('home.student.empty.info-enrollmentNotEnabled')}
          </div>
          {enableEnrollment ? (
            <input
              type="text"
              ref="enrollClassCodePlaceholder"
              placeholder={I18n.t('home.student.empty.joinPlaceholder')}
              onKeyUp={this.classCodeHandler.bind(this)}
            />
          ) : (
            undefined
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    i18n: state.i18n,
    emptyClassrooms: state.theme.images.placeholders.emptyClassrooms,
    enableEnrollment: state.account.configuration.enableEnrollment
  };
}

function mapDispatchToProps(dispatch) {
  return {
    classroomActions: bindActionCreators(classroomActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EmptyClassroomPlaceholder);
